export default __webpack_public_path__ + "static/media/energy.2c3c662f.png";